/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Movement_From_LabelInputs */



/**
* | output |
* | --- |
* | "From (stock source)" |
*
* @param {Promo_Movement_From_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_movement_from_label = /** @type {((inputs?: Promo_Movement_From_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Movement_From_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Depuis (source du stock)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desde (fuente del stock)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("De (fonte do estoque)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Da (fonte dello stock)")
	return /** @type {LocalizedString} */ ("From (stock source)")
});